import {providerOrderTrackingConfig} from './orderTracking';
import {providerOrdersControl} from './orderLimits';

export const providerConfiguration = [
  {providerOrderTrackingConfig},
  {providerOrdersControl},
];
